import React from "react";

function Video() {
  return (
    <div>
      <h2 className="text-center my-5">Видео о проекте</h2>
      <div className="container">
        <iframe
          className="w-100 shadow-custom my-5"
          height="800"
          src="https://www.youtube.com/embed/mYXOSKg3ntY"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
}

export default Video;
